import { createContext, useContext, useState } from 'react';
import { content, products } from '../content';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState('en');
  
  const toggleLanguage = () => {
    setLang(prev => prev === 'en' ? 'fr' : 'en');
  };
  
  const t = content[lang];
  const p = products[lang];
  
  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLanguage, t, p }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
